module.exports = __webpack_public_path__ + "img/wx.0d9480ca.png";